import { render } from "./AdminEdit.vue?vue&type=template&id=48a6b806&scoped=true"
import script from "./AdminEdit.vue?vue&type=script&lang=js"
export * from "./AdminEdit.vue?vue&type=script&lang=js"

import "./AdminEdit.vue?vue&type=style&index=0&id=48a6b806&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a6b806"]])

export default __exports__